import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteAMenu, getMenus, resetState } from "../../features/cms/menus/cmsMenusSlice";
import CustomModal from "../../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Location",
    dataIndex: "location",
  },
  {
    title: "Active",
    dataIndex: "active",
  },
  {
    title: "Items Count",
    dataIndex: "itemsCount",
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const MenuList = () => {
  const [open, setOpen] = useState(false);
  const [menuId, setMenuId] = useState("");
  const showModal = (e) => {
    setOpen(true);
    setMenuId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getMenus());
  }, [dispatch]);
  const getMenuState = useSelector((state) => state.cmsMenus.menus);
  const data1 = [];
  for (let i = 0; i < getMenuState.length; i++) {
    data1.push({
      key: i + 1,
      name: getMenuState[i].name,
      location: getMenuState[i].location,
      active: getMenuState[i].isActive ? "Yes" : "No",
      itemsCount: getMenuState[i].items?.length || 0,
      action: (
        <>
          <Link
            to={`/admin/cms/menu/${getMenuState[i]._id || getMenuState[i].id}`}
            className=" fs-3 text-danger"
          >
            <BiEdit />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(getMenuState[i]._id || getMenuState[i].id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }
  const deleteMenu = (e) => {
    dispatch(deleteAMenu(e));
    setOpen(false);
    setTimeout(() => {
      dispatch(getMenus());
    }, 100);
  };
  return (
    <div>
      <h3 className="mb-4 title">Menus List</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteMenu(menuId);
        }}
        title="Are you sure you want to delete this menu?"
      />
    </div>
  );
};

export default MenuList;

